module.exports = "/fast-coin/img/coin/anim/shine_2/shine_2_015.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_2/shine_2_015.png
// module id = 2362
// module chunks = 5